import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { translate } from "../../i18n/customI18nProvider";
export function AskNameModal({ name, open, onClose, onConfirm }) {
    const [inputName, setInputName] = React.useState(name || "");
    const [remindName, setRemindName] = React.useState(true);
    const MAX_NAME_LENGTH = 30;

    React.useEffect(() => {
        if(name && name.length > MAX_NAME_LENGTH) {
            setInputName(name.slice(0, MAX_NAME_LENGTH));
        } else {
            setInputName(name || "");
        }
    }, [name, open]);

    const handleConfirm = () => {
        onConfirm(inputName.trim(), remindName);
    }

    const handleChange = (e) => {
        if(e.target.value.length > MAX_NAME_LENGTH) {
            let truncated = e.target.value.slice(0, MAX_NAME_LENGTH);
            setInputName(truncated);
            return;
        }
        setInputName(e.target.value);
    }

    return (
        <Dialog fullWidth={true} open={open} onClose={onClose} PaperProps={{ sx: { position: 'absolute', top: 16, m: 0 } }}>
            <DialogTitle>{translate('custom.enter_name')}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label={translate('custom.name')}
                    type="text"
                    fullWidth
                    value={inputName}
                    onChange={handleChange}
                />
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    {translate('custom.max_name_length').replace('{{length}}', MAX_NAME_LENGTH)}
                </Typography>
                <FormGroup>
                    <FormControlLabel control={<Checkbox checked={remindName} onChange={(e) => setRemindName(e.target.checked)} />} label={translate('custom.remind_name')} />
                </FormGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{translate('custom.cancel')}</Button>
                <Button onClick={handleConfirm} disabled={inputName.trim() === ""} variant="contained">{translate('custom.confirm')}</Button>
            </DialogActions>
        </Dialog>
    );
}